import { Drawer, DrawerContent, DrawerHeader, DrawerTitle } from "@/components/ui/drawer";
import { ToofiSidebar } from "@/components/ui/reader-ai/toofi-sidebar";
import type { ReaderAiThread } from "@/types/agentic-chat";
import type { ToofiShellSidebarView } from "@/components/ui/reader-ai/types";

type ToofiMobileNavDrawerProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentView: ToofiShellSidebarView;
  threads: ReaderAiThread[];
  activeThreadId: string | null;
  artifactCount: number;
  onViewChange: (view: ToofiShellSidebarView) => void;
  onNewChat: () => void;
  onStartTemporaryChat?: () => void;
  onSelectThread: (threadId: string) => void;
  onRenameThread: (threadId: string, title: string) => void;
  onDeleteThread: (threadId: string) => void;
  onPinThread?: (threadId: string) => void;
  onUnpinThread?: (threadId: string) => void;
  onArchiveThread?: (threadId: string) => void;
  onRestoreThread?: (threadId: string) => void;
  onStartSimilarChat?: (threadId: string) => void;
  onSetThreadMemoryMode?: (threadId: string, mode: "default" | "temporary") => void;
};

export function ToofiMobileNavDrawer({
  open,
  onOpenChange,
  currentView,
  threads,
  activeThreadId,
  artifactCount,
  onViewChange,
  onNewChat,
  onStartTemporaryChat,
  onSelectThread,
  onRenameThread,
  onDeleteThread,
  onPinThread,
  onUnpinThread,
  onArchiveThread,
  onRestoreThread,
  onStartSimilarChat,
  onSetThreadMemoryMode,
}: ToofiMobileNavDrawerProps) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent
        overlayClassName="bg-slate-700/12 backdrop-blur-[2px]"
        className="flex max-h-[88dvh] flex-col rounded-t-[2rem] border-x-0 border-b-0 border-t border-slate-200/80 bg-[linear-gradient(180deg,rgba(255,255,255,0.98),rgba(248,250,252,0.95))] px-0 pb-[max(1rem,env(safe-area-inset-bottom))] pt-3 shadow-[0_-24px_60px_rgba(15,23,42,0.12)]"
      >
        <DrawerHeader className="px-4 pb-2 text-left">
          <DrawerTitle className="text-base font-semibold text-slate-950">Toofi</DrawerTitle>
        </DrawerHeader>
        <div className="min-h-0 flex-1 overflow-hidden">
          <ToofiSidebar
            compact
            className="h-full"
            threads={threads}
            activeThreadId={activeThreadId}
            artifactCount={artifactCount}
            currentView={currentView}
            onViewChange={(view) => {
              onViewChange(view);
              onOpenChange(false);
            }}
            onNewChat={() => {
              onNewChat();
              onOpenChange(false);
            }}
            onStartTemporaryChat={
              onStartTemporaryChat
                ? () => {
                    onStartTemporaryChat();
                    onOpenChange(false);
                  }
                : undefined
            }
            onSelectThread={(threadId) => {
              onSelectThread(threadId);
              onOpenChange(false);
            }}
            onRenameThread={onRenameThread}
            onDeleteThread={onDeleteThread}
            onPinThread={onPinThread}
            onUnpinThread={onUnpinThread}
            onArchiveThread={onArchiveThread}
            onRestoreThread={onRestoreThread}
            onStartSimilarChat={onStartSimilarChat}
            onSetThreadMemoryMode={onSetThreadMemoryMode}
          />
        </div>
      </DrawerContent>
    </Drawer>
  );
}
